module.exports = "/assets/js/ccadd25ac9dd1721e5d583d9c7ffe2bb.svg";